import React from 'react';
import { styled, Shape, LazyImage, Body, Caption, Currency } from '@teko/ds-desktop';
import { t } from '../../../i18n.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = styled.div((props) => `
  display: flex;
  padding: 12px;
  align-items: center;
  background: white;
  border-bottom: ${props.border ? "1px" : "0px"} solid #e0e0e0;
`);
const Description = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
`;
const FlexAuto = styled(Shape)`
  flex: 0 0 auto;
`;
const SellerLine = (_a) => {
  var _b = _a, {
    seller,
    total,
    selectedCount,
    totalCount,
    border = true,
    isLogoHidden = false,
    alterName
  } = _b, props = __objRest(_b, [
    "seller",
    "total",
    "selectedCount",
    "totalCount",
    "border",
    "isLogoHidden",
    "alterName"
  ]);
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    border
  }), isLogoHidden ? null : /* @__PURE__ */ React.createElement(FlexAuto, {
    marginRight: "s12"
  }, /* @__PURE__ */ React.createElement(LazyImage, {
    contain: true,
    src: (seller == null ? void 0 : seller.logo) || "",
    border: true,
    width: 38,
    height: 38,
    borderRadius: 19
  })), /* @__PURE__ */ React.createElement(Description, null, /* @__PURE__ */ React.createElement(Body, {
    weight: "medium"
  }, alterName ? alterName : seller == null ? void 0 : seller.displayName), totalCount && /* @__PURE__ */ React.createElement(Caption, {
    level: 1,
    color: "textSecondary"
  }, selectedCount, "/", totalCount, " ", t("s\u1EA3n ph\u1EA9m"))), total && /* @__PURE__ */ React.createElement(FlexAuto, {
    style: { fontWeight: 500 }
  }, /* @__PURE__ */ React.createElement(Currency, {
    value: total,
    color: "#eb1f3a"
  })));
};

export { SellerLine };
